import AbstractAction from "../AbstractAction";

export default class UpdateLayerOpacityAction extends AbstractAction {
    constructor(provider, layer) {
        super(provider);

        this.layer = layer;
        this.oldOpacity = layer.opacity;
        this.newOpacity = layer.opacity;
    }

    update(value) {
        this.newOpacity = value;
        this.layer.opacity = value;
    }

    finish() {
        if (this.newOpacity === this.oldOpacity) {
            super.discard();
            return;
        }
        this.layer.opacity = this.newOpacity;
        super.finish();
    }

    undo() {
        this.layer.opacity = this.oldOpacity;
        this.layer.row.updateOpacitySlider(this.oldOpacity);
    }

    redo() {
        this.layer.opacity = this.newOpacity;
        this.layer.row.updateOpacitySlider(this.newOpacity);
    }
}
